import React from "react";
import { TableContentForRouteSummaryReport } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const columnNames = this.props.columnNames;
        const fieldDeductions = this.props.fieldDeductions;
        const factoryDedutions = this.props.factoryDedutions;
        const bagcount = this.props.bagcount;
        const fullTotalRow = this.props.fullTotalRow;

        return (
            <div>
                <h3><center><u>Route Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                <div>
                    <div className="card pt-2 pl-3 pr-3" style={{ width: "10rem;" }}>
                        {/* <div className="card-header"><h6>Gross Variance Bag Count</h6></div> */}
                        <div className="card-body">
                            {/* <p className="d-inline pr-3"><b>Greater Than : </b> {bagcount.greaterThan} bags</p>
                            <p className="d-inline pr-3"><b>Less Than: </b> {bagcount.lessThan} bags</p> */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <table >
                                <thead>
                                    <tr>
                                        <th colSpan="2"></th>
                                        <th colSpan={4 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                        <th colSpan={4 + factoryDedutions.length} style={{ textAlign: "center" }}>Factory Weight /Kg</th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                      
                                    </tr>
                                    <tr>
                                        {columnNames.map((x, index) => {
                                            if(x=="+-/Kg"){
                                                                    return (
                                                                    <th key={index} style={{ background:"yellow",textAlign: "right" }}>{x}</th>
                                                                );
                                                                }else if(x=="+-/Kg"){
                                                                    return (
                                                                    <th key={index} style={{ background:"yellow",textAlign: "right" }}>{x}</th>
                                                                );
                                                                }else{
                                                                    return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                                }
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForRouteSummaryReport
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                  <tfoot>
                                                        <tr>
                                                            <th>Total</th>
                                                            {contentRowNames.map((x, i) => {
                                                                var res = fullTotalRow.find(y => y.name === x.toString());                                                                
                                                                if (res) {
                                                  
                                                                    if(x.toString()=="loexx"){
                                                                        return (
                                                                        <th key={i} style={{ background:"yellow",textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );
                                                                    }else if(x.toString()=="grossBalance"){
                                                                        return (
                                                                        <th key={i} style={{ background:"yellow",textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );
                                                                    }else{
                                                                        return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );                 
                                                                    }
                                                                    
                                                                }
                                                            })}
                                                        </tr>
                                                    </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}